import { IPhoneNumber } from './phone-number.interface';
import { UserAvailabilityType } from '../types';
import { IGroup, IViewGroup } from './group.interface';

export interface IUserAvailability {
  id: number;
  status: UserAvailabilityType;
  userId: number;
}

export interface IUserProfile {
  countryCode: string;
  phoneNumber: string;
  phoneNumberObj: IPhoneNumber;
  fullPhoneNumber: string;
  secondEmail?: string;
  ceaNumber: string;
  designation: string;
}

export interface IUser {
  id: number;
  firstName: string;
  lastName: string;
  fullName: string;
  fullNameWithStatus: string;
  username: string;
  email: string;
  code?: string;
  role?: string;

  avatar: string | null;
  phoneNumber: string | null;
  profile: IUserProfile;
  status: 'activated' | 'deactivated';

  signature?: string;

  activated: string;
  createdAt: string;
  lastLogin: string;
  updatedAt: string;
  groups: IGroup[];
  viewGroup: IViewGroup[];

  teamLeadId?: number;
  teamName?: string;
  teamLead?: IUser;

  // BE Stuff
  ssoProvider: string;
  ssoUserId: string;
  forceChangePassword: any;
  lastChangePasswordAt: string | null;
  DN?: string;
}

export interface IAddUserResult {
  profile: Partial<IUserProfile>;
  id: number;
  username: string;
  message: string;
}

export interface IUserAuditBody {
  actor: Pick<IUser, 'id' | 'username' | 'email'>;
  user: Pick<IUser, 'id' | 'username' | 'email'>;
  viewGroup: Pick<IViewGroup, 'name' | 'id'>;
}
